<template>
  <v-dialog :value="recordingsDialog" @click:outside="closeDialog()">
    <v-card elevation="6" outlined>
      <vuescroll
        :ops="{
          bar: {
            background: '#bacfcec0',
            keepShow: true,
          },
        }"
      >
        <v-tabs v-model="recordingsTab" align-with-title>
          <v-tab> Regulares </v-tab>
          <v-tab> Colas </v-tab>
        </v-tabs>
        <v-tabs-items v-model="recordingsTab">
          <v-tab-item>
            <v-data-table
              :headers="recordingsTableHeaders"
              :loading="loading"
              :items="recordingList"
              class="elevation-0"
              :items-per-page="10"
            >
              <template v-slot:[`item.hour`]="{ item }">
                <span>{{ item.fecha | getHourFormat }}</span>
              </template>

              <template v-slot:[`item.duracion`]="{ item }">
                <span>
                  {{ item.duracion | secondsToTimeFormat }}
                </span>
              </template>

              <template v-slot:[`item.hablado`]="{ item }">
                <span>
                  {{ item.hablado | secondsToTimeFormat }}
                </span>
              </template>

              <template v-slot:[`item.estado`]="{ item }">
                <v-chip color="transparent" small>
                  <v-icon left small :color="getSpanishState(item.estado).color"
                    >{{ getSpanishState(item.estado).icon }}
                  </v-icon>
                  {{ getSpanishState(item.estado).text }}
                </v-chip>
              </template>

              <template v-slot:[`item.recordingfile`]="{ item }">
                <div class="pt-2 pb-1" v-if="item.recordingfile">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <audio controls preload="none" v-bind="attrs" v-on="on">
                        <source
                          :src="
                            'https://' +
                              recordingUrl +
                              recordingPathGenerator(item.recordingfile)
                          "
                          type="audio/wav"
                        />

                        <source
                          :src="
                            'https://' +
                              recordingUrl +
                              recordingPathGenerator(item.recordingfile, true)
                          "
                          type="audio/mpeg"
                        />
                        <p>
                          Tu navegador no implementa el elemento audio.
                        </p>
                      </audio>
                    </template>
                    <span>{{ item.recordingfile }}</span>
                  </v-tooltip>
                </div>

                <span class="caption grey--text" v-else>No disponible</span>
              </template>
              <template v-slot:[`item.action`]="{ item }">
                <v-btn small rounded evelation="0" @click="closeDialog(item)"
                  >Seleccionar</v-btn
                >
              </template>
            </v-data-table>
          </v-tab-item>
          {{/* Queue Recordings */}}
          <v-tab-item>
            <v-data-table
              :headers="recordingsQueueTableHeaders"
              :items="recordingQueueList"
              :loading="loading"
              class="elevation-0"
              :items-per-page="10"
            >
              <template v-slot:[`item.hour`]="{ item }">
                <span>{{ item.cdr.fecha | getHourFormat }}</span>
              </template>
              <template v-slot:[`item.src`]="{ item }">
                <span>{{ item.cdr.src }}</span>
              </template>
              <template v-slot:[`item.dst`]="{ item }">
                <span>{{ item.cdr.dst }}</span>
              </template>

              <template v-slot:[`item.duracion`]="{ item }">
                <span>
                  {{ item.cdr.duracion | secondsToTimeFormat }}
                </span>
              </template>

              <template v-slot:[`item.hablado`]="{ item }">
                <span>
                  {{ item.cdr.hablado | secondsToTimeFormat }}
                </span>
              </template>

              <template v-slot:[`item.estado`]="{ item }">
                <v-chip color="transparent" small>
                  <v-icon left small :color="getSpanishState(item.cdr.estado).color"
                    >{{ getSpanishState(item.cdr.estado).icon }}
                  </v-icon>
                  {{ getSpanishState(item.cdr.estado).text }}
                </v-chip>
              </template>

              <template v-slot:[`item.recordingfile`]="{ item }">
                <div class="pt-2 pb-1" v-if="item.cdr.recordingfile">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <audio controls preload="none" v-bind="attrs" v-on="on">
                        <source
                          :src="
                            'https://' +
                              recordingUrl +
                              recordingPathGenerator(item.cdr.recordingfile)
                          "
                          type="audio/wav"
                        />

                        <source
                          :src="
                            'https://' +
                              recordingUrl +
                              recordingPathGenerator(item.cdr.recordingfile, true)
                          "
                          type="audio/mpeg"
                        />
                        <p>
                          Tu navegador no implementa el elemento audio.
                        </p>
                      </audio>
                    </template>
                    <span>{{ item.cdr.recordingfile }}</span>
                  </v-tooltip>
                </div>

                <span class="caption grey--text" v-else>No disponible</span>
              </template>
              <template v-slot:[`item.action`]="{ item }">
                <v-btn small rounded evelation="0" @click="closeDialog(item.cdr)"
                  >Seleccionar</v-btn
                >
              </template>
            </v-data-table>
          </v-tab-item>
        </v-tabs-items>
      </vuescroll>
      <v-card-actions class="mx-2">
        <v-hover v-slot:default="{ hover }">
          <v-btn
            text
            rounded
            class="mr-1"
            :color="hover ? 'error' : 'grey'"
            @click="closeDialog()"
          >
            Cancelar
          </v-btn>
        </v-hover>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import axios from "axios";
import vuescroll from "vuescroll";
import recordingPathGenerator from "@/components/Utils/recordingPathGenerator";
export default {
  components: { vuescroll },
  props: {
    recordingsDialog: {
      type: Boolean,
    },
    extension: {
      type: String,
    },
    dateStart: {
      type: String,
    },
    dateEnd: {
      type: String,
    },
    queue: {
      type: String,
    },
    phone: {
      type: String,
    },
  },
  data() {
    return {
      recordingsTab: 0,
      recordingPathGenerator: recordingPathGenerator,
      recordingsTableHeaders: [
        { text: "Origen", value: "src", width: "10%" },
        {
          text: "Destino",
          value: "dst",
          width: "10%",
        },
        {
          text: "Hora",
          value: "hour",
          width: "10%",
          align: "center",
        },
        {
          text: "Duración",
          align: "right",
          value: "duracion",
          width: "10%",
          align: "center",
        },
        {
          text: "Hablado",
          align: "right",
          value: "hablado",
          width: "15%",
          align: "center",
        },
        {
          text: "Estado",
          value: "estado",
          width: "10%",
        },
        {
          text: "Grabación",
          align: "center",
          value: "recordingfile",
          filterable: false,
          width: "25%",
        },
        {
          text: "Accion",
          align: "center",
          value: "action",
          filterable: false,
          width: "15%",
        },
      ],
      recordingsQueueTableHeaders: [
        { text: "Agente", value: "agent", width: "10%" },
        { text: "Origen", value: "src", width: "10%" },
        {
          text: "Destino",
          value: "dst",
          width: "10%",
        },
        {
          text: "Hora",
          value: "hour",
          width: "10%",
          align: "center",
        },
        {
          text: "Duración",
          align: "right",
          value: "duracion",
          width: "10%",
          align: "center",
        },
        {
          text: "Hablado",
          align: "right",
          value: "hablado",
          width: "10%",
          align: "center",
        },
        {
          text: "Estado",
          value: "estado",
          width: "10%",
        },
        {
          text: "Grabación",
          align: "center",
          value: "recordingfile",
          filterable: false,
          width: "15%",
        },
        {
          text: "Accion",
          align: "center",
          value: "action",
          filterable: false,
          width: "15%",
        },
      ],
      loading: false,
      recordingUrl: "",
      recordingList: [],
      recordingQueueList: [],
      recordingQueueUrl: "",
    };
  },
  created() {
    this.getRecordings();
  },
  methods: {
    async getRecordings() {
      this.loading = true;
      const accessToken = localStorage.getItem("token");
      let queueValue = this.queue ? this.queue.toString() : null;

      // console.log("aquiiiiiiiiiiiiiiii", queueValue);

      try {
        const res = await axios.all([
          axios.post(
            `${process.env.VUE_APP_ROOTAPI}/quality/recording`,
            {
              dateStart: this.dateStart,
              dateEnd: this.dateEnd,
              extension: this.extension,
              dst: this.phone,
            },
            {
              headers: { Authorization: `Bearer ${accessToken}` },
            }
          ),
          axios.post(
            `${process.env.VUE_APP_ROOTAPI}/quality/recording_user_queue`,
            {
              dateStart: this.dateStart,
              dateEnd: this.dateEnd,
              extension: this.extension,
              queue: queueValue,
              dst: this.phone,
            },
            {
              headers: { Authorization: `Bearer ${accessToken}` },
            }
          ),
        ]);
        this.recordingUrl = res[0].data.url;
        this.recordingList = res[0].data.data.filter((rec) => rec.estado === "ANSWERED");
        this.recordingQueueUrl = res[1].data.url;
        this.recordingQueueList = res[1].data.data.data.filter(
          (rec) => rec.cdr?.estado === "ANSWERED"
        );
      } catch (error) {
        console.error("Error de recordings", error);
        this.$snotify.error("Hubo un error en la consulta.", "Error");
      }
      this.loading = false;
    },
    closeDialog(data = false) {
      this.$emit("dialog:close", {
        url: this.recordingsTab === 0 ? this.recordingUrl : this.recordingQueueUrl,
        item: data,
      });
    },

    /**
     * [Obtener estado en español]
     * @param {string} state [Estado de la llamada]
     */
    getSpanishState(state) {
      if (state == "ANSWERED") {
        return {
          text: "Contestada",
          color: "success",
          icon: "mdi-phone-outline",
        };
      } else {
        return {
          text: "No contestada",
          color: "error",
          icon: "mdi-call-missed",
        };
      }
    },
  },
};
</script>

<style></style>
